import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
import { AppComponentBase } from '~/shared/app-component-base';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_cashboxclosed',
    templateUrl: './print_cashboxclosed.html',
})
export class PrintCashBoxClosed extends AppComponentBase implements OnInit {
    public init: boolean;

    constructor(public tournamentsService: TournamentsService, private _injector: Injector) {
        super(_injector);
        SetLanguage('', '');
    }
    public ngOnInit() {
        SetLanguage('', '');
        if (this.init) {
            return;
        }
        this.init = true;
    }
}
